import { FileDownloadResponseSchema } from '@easy-genomics/shared-lib/src/app/schema/nf-tower/file/request-file-download';
import { FileDownloadResponse } from '@easy-genomics/shared-lib/src/app/types/nf-tower/file/request-file-download';
import {
  CreateWorkflowLaunchRequest,
  ListWorkflowsResponse,
  DescribeWorkflowResponse,
  Workflow,
  WorkflowLogResponse,
} from '@easy-genomics/shared-lib/src/app/types/nf-tower/nextflow-tower-api';
import { httpClient } from '@/lib/api/client';
import { validateApiResponse } from '@/lib/api-utils';

class SeqeraRunsModule {
  async createPipelineRun(labId: string, pipelineLaunchRequest: CreateWorkflowLaunchRequest): Promise<any> {
    const res = await httpClient.callSeqera<any>(
      'POST',
      `/workflow/create-workflow-execution?laboratoryId=${labId}`,
      pipelineLaunchRequest,
    );
    console.log('createPipelineRun response:', res);
    if (!res) {
      console.error('Error calling create pipeline run API');
      throw new Error('Failed to create pipeline run');
    }
    return res;
  }

  async list(labId: string): Promise<Workflow[]> {
    const res = await httpClient.callSeqera<ListWorkflowsResponse>(
      'GET',
      `/workflow/list-workflows?laboratoryId=${labId}`,
    );
    if (!res) {
      throw new Error('Failed to retrieve workflows');
    }

    const workflows = res.workflows?.map((wfMeta) => wfMeta.workflow as Workflow);

    return workflows || [];
  }

  async cancelPipelineRun(labId: string, seqeraRunId: string): Promise<any> {
    const res = await httpClient.callSeqera<any>(
      'PUT',
      `/workflow/cancel-workflow-execution/${seqeraRunId}?laboratoryId=${labId}`,
    );

    if (!res) {
      console.error('Error calling cancel pipeline run API');
      throw new Error('Failed to cancel pipeline run');
    }
    return res;
  }

  async readWorkflowReports(workspaceId: string, labId: string): Promise<any> {
    const res = await httpClient.callSeqera<any>(
      'GET',
      `/workflow/read-workflow-reports/${workspaceId}?laboratoryId=${labId}`,
    );
    if (!res) {
      console.error('Error calling read workflow reports API');
      throw new Error('Failed to read workflow reports');
    }
    return res;
  }

  async downloadSeqeraFile(labId: string, contentUri: string): Promise<FileDownloadResponse> {
    const res: FileDownloadResponse | undefined = await httpClient.callSeqera<FileDownloadResponse>(
      'POST',
      '/file/request-file-download',
      {
        LaboratoryId: labId,
        ContentUri: contentUri,
      },
    );

    if (!res) {
      console.error('Error calling file download API');
      throw new Error('Failed to perform file download');
    }

    validateApiResponse(FileDownloadResponseSchema, res);
    return res;
  }

  async readWorkflowLogs(labId: string, workflowId: string): Promise<WorkflowLogResponse> {
    const res = await httpClient.callSeqera<WorkflowLogResponse>(
      'GET',
      `/workflow/read-workflow-logs/${workflowId}?laboratoryId=${labId}`,
    );
    if (!res) {
      throw new Error('Failed to read workflow logs');
    }
    return res;
  }

  async get(labId: string, seqeraRunId: string): Promise<Workflow> {
    const res = await httpClient.callSeqera<DescribeWorkflowResponse>(
      'GET',
      `/workflow/read-workflow/${seqeraRunId}?laboratoryId=${labId}`,
    );

    if (!res) {
      console.error('Error calling get pipeline run API');
      throw new Error('Failed to get pipeline run');
    }

    return res.workflow as Workflow;
  }
}

export default SeqeraRunsModule;
